var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"id":"yhphoto"}},[_c('v-main',[_c('v-container',{staticClass:"px-0 py-0",attrs:{"fluid":""}},[(_vm.loaded)?[_c('parallaxHeader'),_c('social-network'),_c('about-me'),_c('contact'),_c('footer-bar')]:_vm._e()],2)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }